// Named analytics hooks only (Build 01/02). No live analytics destinations
// are connected yet, events are pushed to window.dataLayer + console so they
// can be wired to GTM later without touching component code.
export const track = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", event, params);
    }
  } catch (e) {
    /* no-op */
  }
};
